import React, { useState, useEffect } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import FeedCard from '../../orden/comentarios/FeedCard';
import FeedProvider from '../../orden/comentarios/FeedProvider';

import PropTypes from 'prop-types';

const SeccionComentarios = (

    {
    idLicencia,
    licencias,
    cargando
    }


) => {
    // Estados locales para comentarios
    const [comentarios, setComentarios] = useState([]);
    const [comentario, setComentario] = useState('');
    const [procesandoComentario, setProcesandoComentario] = useState(false);

    // Hook de autenticación
    const { token, setToken, idUsuario, nombreCompleto } = useToken();
    
    // Hook de notificaciones
    const { showErrorToast } = useToast();

    /**
     * Obtiene los comentarios de la licencia
     */
    const obtenerComentarios = async () => {


        try {
            const response = await fetch(`/api/licencia/ObtieneComentariosLicencia/?id=${idLicencia}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const detalles = JSON.parse(data.detalles);

                    console.log("Seccion Comentarios", detalles)
                    setComentarios(Array.isArray(detalles.table2) ? detalles.table2 : []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    window.location.href = "";
                }
            }
        } catch (error) {
            console.error('Error al obtener comentarios:', error);
        }
    };

    /**
     * Guarda un comentario en la licencia
     * @param {any} e
     * @returns
     */
    const submitComment = async (e) => {

        e.preventDefault();
        if (comentario == '') {
            return;
        }
        setProcesandoComentario(true);

        var jDataSend = {}
        jDataSend.idLicencia = licencias.idLicencia;
        jDataSend.vComentario = comentario;
        jDataSend.idTipoComentario = 1;

        const response = await fetch("/api/licencia/RegistrarComentario/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== REGISTRAR COMENTARIO ====");

            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                console.log("detalles: ", detalles);

                setComentarios([detalles.table2[0], ...comentarios]);

                var objToActionString = crearObjAction(2, "/licencias/detalle/" + licencias.idLicencia, '', '');

                var jsonData = {};
                jsonData.idLicencia = licencias.idLicencia;
                //jsonData.idUsuario = licencias.idUsuario;
                var jsonString = JSON.stringify(jsonData);

                guardarNotificacion(
                    "Se hizo un comentario en una licencia",
                    "<b> " + nombreCompleto + "</b> hizo un comentario en la licencia <b>#" + licencias.idLicencia + "</b> : <i> '" + comentario.substring(0, 3) + "...'</i>",
                    0,
                    objToActionString,
                    9,
                    jsonString
                );

                setProcesandoComentario(false);
                setComentario('');

            } else {

                showErrorToast(data.vMessage);
                setProcesandoComentario(false);
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            setProcesandoComentario(false);
            console.log(response);
        }

    };


    /**
     * Guarda una notificaci�n
     */
    const guardarNotificacion = async (vTitulo, vCuerpo, idUsuarioTarget, objToAction, idTipoNotificacion, jsonData = null) => {

        var jDataSend = {};
        jDataSend.vTitulo = vTitulo;
        jDataSend.vCuerpo = vCuerpo;
        jDataSend.idUsuarioTarget = idUsuarioTarget;
        jDataSend.objToAction = objToAction;
        jDataSend.idTipoNotificacion = idTipoNotificacion;
        jDataSend.jsonData = jsonData;

        const response = await fetch("/api/leads/guardarNotificacion/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== NOTIFICACI�N GUARDADA ====");

            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);
            console.log("objToAction: ", objToAction);
            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                console.log("detalles: ", detalles);

                var notificacionesList = detalles.table2;
                console.log("notificacionesList: ", notificacionesList);

                var jDataSendNoti = {}
                jDataSendNoti.notificacionesList = notificacionesList;

                const responseNoti = await fetch("/api/account/EnviarNotificacionPush/",
                    {
                        method: 'POST',
                        headers:
                        {
                            'Authorization': 'Bearer ' + token,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(jDataSendNoti)
                    }).catch((error) => {

                        showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                        console.log('Hubo un problema con la peticion Fetch:' + error);
                    });

                if (responseNoti.ok) {
                    if (responseNoti.iResponseType == 1) {
                        console.log("Exito!");
                    }
                }


            } else {

                showErrorToast(data.vMessage);
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);

            console.log(response);
        }
    };


    /**
     * Crea un objeto de acci�n que especifica la acci�n a realizar al hacer clic en una notificaci�n,
     * ya sea abrir un modal o redireccionar a otra p�gina.
     * @param {any} TypeAction
     * @param {any} vURL
     * @param {any} idModalType
     * @param {any} idLead
     * @returns
     */
    const crearObjAction = (TypeAction, vURL, idModalType, idLead,) => {
        var objToAction = {};
        var objDetalles = {};
        var objData = {};

        objData.idLead = idLead;

        objDetalles.vUrl = vURL;
        objDetalles.idModalType = idModalType;
        objDetalles.data = objData

        objToAction.TypeAction = TypeAction;
        objToAction.detalles = objDetalles;

        var objToActionString = JSON.stringify(objToAction);
        console.log("objToAction: ", objToActionString);
        return objToActionString;
    };

    // Cargar comentarios al montar el componente
    useEffect(() => {
        obtenerComentarios()
    }, [idLicencia]);

    return (
        <FeedProvider>
            {cargando ? (
                <></>
            ) : (
                <FeedCard
                    comentarios={comentarios}
                    procesandoComentario={procesandoComentario}
                    setComentario={setComentario}
                    comentario={comentario}
                    submitComment={submitComment}
                    idUsuario={Number(idUsuario)}
                    className='mb-2 mb-lg-0'
                />
            )}
        </FeedProvider>
    );
};

SeccionComentarios.propTypes = {
    idLicencia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    licencias: PropTypes.object.isRequired,
    cargando: PropTypes.bool.isRequired
};

export default SeccionComentarios;